import { render, staticRenderFns } from "./CommentEdit.vue?vue&type=template&id=323ff95e&scoped=true&"
import script from "@/scripts/QA/Question/components/Comment/CommentEdit?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/Comment/CommentEdit?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323ff95e",
  null
  
)

export default component.exports